import { render } from "./ReceiptTab.vue?vue&type=template&id=605116ff"
import script from "./ReceiptTab.vue?vue&type=script&lang=js"
export * from "./ReceiptTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__